import { render, staticRenderFns } from "./ClassAssistant.vue?vue&type=template&id=d254a5b0&scoped=true"
import script from "./ClassAssistant.vue?vue&type=script&lang=js"
export * from "./ClassAssistant.vue?vue&type=script&lang=js"
import style0 from "./ClassAssistant.vue?vue&type=style&index=0&id=d254a5b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d254a5b0",
  null
  
)

export default component.exports